<template>
  <!-- 右侧悬浮框 -->
  <div class="right_box">
    <div class="item_style" @click="servicePopup = true">
      <img src="../assets/icon/kefu.png" alt="" class="img" />
      <p>{{ $t('官方客服') }}</p>
    </div>

    <div class="item_style" style="margin-top: 20px" @click="scrollToTop">
      <img src="../assets/icon/top.png" alt="" class="img" />
      <p>{{ $t('回顶部') }}</p>
    </div>

    <!-- 添加成功弹窗 -->
    <div class="succeedPop" v-if="servicePopup">
      <div class="succeedPop-box">
        <img src=".././../static/images/icon/icon20.png" alt="">
        <div class="text-16 box-tit">{{ $t('在线客服欢迎您随时咨询') }}</div>
        <div class="text-16">{{ $t('电话：') }}{{serviceData.service_mobile}}</div>
        <div class="text-16">{{ $t('微信：') }}{{serviceData.service_wechat}}</div>
        <div class="text-16">{{ $t('QQ：') }}12903809147</div>
        <div class="box-btn" @click="servicePopup = false">{{ $t('知道了') }}</div>
      </div>
    </div>

  </div>
</template>

<script>
  import { getconf } from '@/api/user';

  export default {
    name: "rightSuspension",
    data() {
      return {
        servicePopup: false,//客服弹窗
        serviceData: {}//客服内容
      };
    },
    mounted() {
      this.onGetconf();
    },
    methods: {
      //获取配置
      onGetconf() {
        getconf({ module: 'contact' }).then(res => {
          this.serviceData = res.data;
          console.log(this.serviceData);
        })
      },
      // 返回顶部
      scrollToTop() {
        window.scrollTo({
          top: 0,
          behavior: "smooth", // 平滑滚动
        });
      },
    },
    // 销毁轮播图定时器
    beforeDestroy() { },
    computed: {},
  };
</script>

<style scoped lang="scss">
  .expanded {
    max-height: 42px;
    /* 或者使用其他方式动态设置 */
    overflow: hidden;
    /* 防止内容溢出 */
    transition: max-height 0.5s ease-out;
    /* 平滑过渡效果 */
  }

  .openType {
    color: #fd3b00;
    font-size: 14px;
    text-align: right;
  }

  .msg_bg {
    width: 100vw;
    height: 100vh;
    /* background: rgba($color: #000000, $alpha: 0.2); */
    background: rgba(0, 0, 0, 0.2);
    position: fixed;
    top: 0;
    left: 0;
  }

  .msg_popup {
    width: 1136px;
    height: 523px;
    display: flex;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 16px;
    overflow: hidden;

    .msg_left {
      width: 413px;
      padding: 24px 20px;
      background: #fff;
      box-sizing: border-box;

      .msg_item {
        width: 373px;
        height: 76px;
        display: flex;
        padding: 0 16px;
        margin-top: 16px;
        border-radius: 8px;
        align-items: center;
        background: #f8f8f8;
        box-sizing: border-box;

        .msg_img {
          width: 48px;
          height: 48px;
          margin-right: 12px;
        }
      }
    }

    .msg_right {
      flex: 1;
      padding: 24px;
      background: #f8f8f8;
      box-sizing: border-box;

      .msg_content {
        height: 450px;
        overflow-y: scroll;
        margin-top: 20px;

        .content_item {
          width: 675px;
          padding: 16px;
          margin-bottom: 12px;
          box-sizing: border-box;
          background: #fff;
        }
      }
    }
  }

  .right_box {
    position: fixed;
    right: 0;
    top: 40%;
    z-index: 900;
  }

  .item_style {
    width: 84px;
    height: 92px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    background: #ffffff;
    border: 1px solid #eeeeee;
    cursor: pointer;
  }

  .img {
    width: 24px;
    height: 24px;
    margin-bottom: 10px;
  }

  /**客服弹窗 */
  .succeedPop {
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    left: 0;
    /* // z-index: 999; */
    display: flex;
    align-items: center;
    justify-content: center;

    .succeedPop-box {
      padding: 38px 24px;
      background: #FFFFFF;
      border-radius: 8px;
      width: 400px;
      height: 400px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;

      .box-tit {
        text-align: center;
      }

      .box-icon {
        font-size: 16px;
        font-weight: bold;
        cursor: pointer;
      }

      img {
        width: 120px;
        height: 120px;
      }

      .box-btn {
        width: 181px;
        height: 35px;
        background: #000000;
        border-radius: 8px;
        color: #FFFFFF;
        font-size: 14px;
        text-align: center;
        line-height: 35px;
        cursor: pointer;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/rightSuspension.vue